import AdminPanel from './components/AdminPanel';
import AdminModal from './components/AdminModal';
import './adminPageStyles.scss';
import { Container } from 'react-bootstrap';

const Admin = () => {
	return (
		<div id="admin-page" className="page">
			<Container className="mt-4 mb-4">
				<AdminPanel />
			</Container>
		</div>
	);
};
export default Admin;
